import { AppRegistry } from 'react-native'

import App from 'app/src/App'

AppRegistry.registerComponent('ElSeller', () => App)
AppRegistry.runApplication('ElSeller', {
  rootTag: document.getElementById('root'),
})
